/**
 * @generated SignedSource<<3a1ef5eb9bdfed346a6c64391feb441f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ExportToDocs_stream$data = {
  readonly displayName: string;
  readonly id: string;
  readonly " $fragmentType": "ExportToDocs_stream";
};
export type ExportToDocs_stream$key = {
  readonly " $data"?: ExportToDocs_stream$data;
  readonly " $fragmentSpreads": FragmentRefs<"ExportToDocs_stream">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExportToDocs_stream",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    }
  ],
  "type": "NoteStream",
  "abstractKey": null
};

(node as any).hash = "12a6aa381c1979d2e93e169980448620";

export default node;
